module.exports = __webpack_public_path__ + "static/img/point-font-img@w.214d6da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/point-font-img@w.png
// module id = tarY
// module chunks = 0